import { Modal } from 'flowbite-react';
import { createVehicle } from '../../../../common/services/vehicles.api';
import { useToastContext } from '../../../../common/components/ui/toast/toast.context';
import FormCreateVehicle from '../forms/FormCreateVehicle';

type Props = {
  onClose?: () => void
  onSave: (vehicleId: string) => void
}

export default function ModalCreateVehicle(props: Props) {
  const { notifySuccess, notifyError } = useToastContext()

  const handleCloseModal = () => { props.onClose && props.onClose() }

  async function handleSubmit(dataToSave) {
    try {
      const result = await createVehicle(dataToSave)

      const { ok, data } = result
      if (ok && data) {
        props.onSave((data as { _id: string })?._id)
        notifySuccess(`Veículo "${(data as { licensePlate: string }).licensePlate}" cadastrado!`)
      }
      if (!result.ok) {
        notifyError(result.message as string)
      }

      return data;

    } catch (err) {
      console.log(err)
      notifyError('Erro ao tentar salvar cliente, tente novamente')
      return {
        ok: false,
        data: dataToSave,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        errors: [{ message: (err as any).message, path: [] }]
      }
    }
  }

  return (
    <Modal
      show={true}
      onClose={() => handleCloseModal()}
    >
      <Modal.Header className='text-black'>
        <h2 className='text-black'>{'Novo Veículo'}</h2>
      </Modal.Header>
      <Modal.Body className='text-black' style={{ minHeight: 'calc(50vh - 200px)', height: 'calc(50vh - 200px)' }}>
        <FormCreateVehicle onSubmit={handleSubmit} />
      </Modal.Body>
    </Modal>
  );
}
